// extracted by mini-css-extract-plugin
module.exports = {"inputNumber":"ModalSettlements_inputNumber__1A0R9"};